import { Stack } from '@mui/system';
import ProductReviewsHeader from './ProductReviewsHeader';
import ProductReviewsTable from './ProductReviewsTable';

export default function ProductReviewsPanel() {
  return (
    <Stack spacing={3}>
      <ProductReviewsHeader />
      <ProductReviewsTable />
    </Stack>
  );
}
